<div class="discount-codes">
  @if (settings.headerLabel) {
    <div class="discount-codes__header">{{ settings.headerLabel }}</div>
  }

  <div class="discount-codes__input-row">
    <input type="text" disabled class="discount-codes__input" [placeholder]="settings.title" />
    <button
      type="button"
      class="discount-codes__apply"
      [style.color]="resolved.textColor"
      [style.background-color]="resolved.backgroundColor"
      [style.border-radius.px]="resolved.cornerRadius"
      (mouseenter)="onApplyHoverEnter($event)"
      (mouseleave)="onApplyHoverLeave($event)">
      {{ settings.buttonLabel }}
    </button>
  </div>

  <div class="discount-codes__pills">
    <span class="discount-codes__pill">
      <svg class="discount-codes__pill-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path
          d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
      </svg>
      <span>{{ sample.code }}</span>
      <button type="button" disabled class="discount-codes__pill-remove" aria-label="Remove">×</button>
    </span>
  </div>
</div>
